import {Injectable, Injector, inject} from "@angular/core";
import {dateField, EntityData, EntityModel, field, identifier} from "@fedelta-pos/data-client";
import {OrderType} from '../order/order';

export class OrderTransferTargetData extends EntityData<OrderTransferTargetData> {
    @identifier id: string;
    @field name: string;
    @field appStore: number;
    @field orderType: string;
    @field tableNumber: string;
    @field beaconId: string;
    @dateField created: Date;

    public get orderTypeEnum(): OrderType {
        return OrderType.parse(this.orderType);
    }

    public set orderTypeEnum(orderType: OrderType) {
        this.orderType = OrderType.toString(orderType);
    }
}

export class OrderTransferTargetReferenceData extends EntityData<OrderTransferTargetReferenceData> {
    @identifier id: string;
    @field name: string;
    @dateField created: Date;
}

@Injectable()
export class OrderTransferTargetEntityModel extends EntityModel<OrderTransferTargetData> {
    constructor() {
        console.log("--- OrderTransferTargetEntityModel");
        super(inject(Injector), OrderTransferTargetData);
    }

    override getResourceName(): string {
        return "app-order-transfer-target";
    }
}
